import keyMirror from 'keymirror';

const BUTTON_COLORS = keyMirror({
  primary: null,
  outlined: null,
  danger: null,
});

export { BUTTON_COLORS };
